




















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, PropSync, Vue } from 'vue-property-decorator';
import { i18n } from '@/i18n';
import { CrsForm } from '@resclick/crs-ui';

@Component
export default class RoomTypesSingleTab extends Vue {
  @PropSync('roomType', { required: true }) form!: CrsForm<'properties', 'createRoomType'>;

  get amenities() {
    if (!this.form.fields.amenities) {
      this.form.fields.amenities = {
        layout: {
          roomSize: 0,
          roomSizeUnit: 'SQUARE_METER',
          separateDiningArea: false,
          separateSittingArea: false,
          sharedAccommodations: false,
          desk: false,
          laptopFriendlyWorkspace: false,
          fireplace: false,
          heatedFloors: false,
          accessViaExteriorCorridors: false,
          privatePool: false,
          privatePlungePool: false,
          privateSpaTub: false,
          outdoorSpaces: '',
          individuallyDecorated: false,
          individuallyFurnished: false,
          connectingRoomsAvailable: false,
          yard: false,
          noWindows: false,
          inRoomPlaypen: false,
        },
        bathroom: {
          primaryBathroom: 'PRIVATE_BATHROOM',
          numberOfBathrooms: 0,
          bathrobes: false,
          childrenBathrobes: false,
          heatedFloor: false,
          freeToiletries: false,
          designerToiletries: false,
          soap: false,
          shampoo: false,
          toiletPaper: false,
          hairDryer: false,
          bidet: false,
          bathType: 'SHOWER',
          bathtubType: 'STANDARD_BATHTUB',
          hydroMassageShowerhead: false,
          rainfallShowerhead: false,
        },
        bedding: {
          hypoAllergenicBedding: false,
          premiumBedding: false,
          premiumLinenType: 'EGYPTIAN_COTTON_SHEETS',
          premiumMattressType: '',
          pillowMenu: false,
          downComforter: false,
        },
        accessibility: {
          accessibleBathroom: false,
          rollInShower: false,
          inRoomAccessibility: false,
          availableInGuestrooms: false,
          transferShower: false,
          accessibleBathtub: false,
          portableBathtubSeat: false,
          bathroomGrabBars: false,
          raisedToiletSeat: false,
          visualFireAlarm: false,
          doorbellTelephoneNotification: false,
          vibratingPillowAlarm: false,
          leverDoorHandles: false,
          wheelchairWidthDoorways: false,
          heightAdjustedAmenities: false,
          telephoneAccessibilityKit: false,
        },
        kitchen: {
          available: false,
          type: 'KITCHEN',
          cookwareDishwareUtensils: false,
          dishwasher: false,
          refrigerator: false,
          refrigeratorType: 'REFRIGERATOR',
          oven: false,
          microwave: false,
          microwaveType: 'MICROWAVE',
          riceCooker: false,
          stovetop: false,
          minibar: false,
          minibarType: 'MINIBAR',
        },
        inRoomRefreshment: {
          freeBottledWater: false,
          coffeeTeaMaker: false,
          espressoMaker: false,
          electricKettle: false,
        },
        inRoomEntertainment: {
          television: false,
          televisionType: 'TELEVISION',
          televisionSize: 0,
          dvdPlayer: false,
          iPodDocStation: false,
          mp3DocStation: false,
          videoGameConsole: false,
          computerOrTablet: false,
          computerType: 'COMPUTER',
          channels: [],
        },
        climateControl: {
          airConditioning: false,
          airConditioningType: 'AIR_CONDITIONING',
          fan: false,
          ceilingFan: false,
          portableFan: false,
          heating: false,
          heatingType: 'HEATING',
        },
      };
    }
    return this.form.fields.amenities || {};
  }

  get roomTypeQuery() {
    return {
      filter: {
        isActive: true,
        layout: this.form.fields.layout,
      },
    };
  }

  get smokingOptions() {
    return [
      { label: i18n.t('GENERAL.ALLOWED'), value: 'SMOKING' },
      { label: i18n.t('GENERAL.NOT_ALLOWED'), value: 'NO_SMOKING' },
      { label: i18n.t('GENERAL.IN_SOME_ROOMS'), value: 'IN_SOME_ROOMS' },
    ];
  }

  get costTypeOptions() {
    return [
      { label: i18n.t('GENERAL.FREE'), value: 'FREE' },
      { label: i18n.t('GENERAL.SURCHARGE'), value: 'SURCHARGE' },
    ];
  }

  get costPerTimeOptions() {
    return [
      { label: i18n.t('AMENITIES.PER_DAY'), value: 'PER_DAY' },
      { label: i18n.t('AMENITIES.PER_NIGHT'), value: 'PER_NIGHT' },
      { label: i18n.t('AMENITIES.PER_WEEK'), value: 'PER_WEEK' },
      { label: i18n.t('AMENITIES.PER_STAY'), value: 'PER_STAY' },
    ];
  }

  get areaUnitOptions() {
    return [
      { label: i18n.t('AMENITIES.SQUARE_METER'), value: 'SQUARE_METER' },
      { label: i18n.t('AMENITIES.SQUARE_FEET'), value: 'SQUARE_FEET' },
    ];
  }

  get outdoorSpaceOptions() {
    return [
      { label: i18n.t('AMENITIES.NOT_EXISTS'), value: '' },
      { label: i18n.t('AMENITIES.BALCONY'), value: 'BALCONY' },
      {
        label: i18n.t('AMENITIES.BALCONY_OR_PATIO'),
        value: 'BALCONY_OR_PATIO',
      },
      { label: i18n.t('AMENITIES.DECK_OR_PATIO'), value: 'DECK_OR_PATIO' },
      {
        label: i18n.t('AMENITIES.FURNISHED_BALCONY'),
        value: 'FURNISHED_BALCONY',
      },
      {
        label: i18n.t('AMENITIES.FURNISHED_BALCONY_OR_PATIO'),
        value: 'FURNISHED_BALCONY_OR_PATIO',
      },
      { label: i18n.t('AMENITIES.FURNISHED_LANAI'), value: 'FURNISHED_LANAI' },
      { label: i18n.t('AMENITIES.LANAI'), value: 'LANAI' },
      { label: i18n.t('AMENITIES.PORCH_OR_LANAI'), value: 'PORCH_OR_LANAI' },
      { label: i18n.t('AMENITIES.PATIO'), value: 'PATIO' },
    ];
  }

  get primaryBathroomOptions() {
    return [
      {
        label: i18n.t('AMENITIES.PRIVATE_BATHROOM'),
        value: 'PRIVATE_BATHROOM',
      },
      {
        label: i18n.t('AMENITIES.PRIVATE_BATHROOM_OUTSIDE'),
        value: 'PRIVATE_BATHROOM_OUTSIDE',
      },
      {
        label: i18n.t('AMENITIES.PARTIALLY_OPEN_BATHROOM'),
        value: 'PARTIALLY_OPEN_BATHROOM',
      },
      {
        label: i18n.t('AMENITIES.SHARED_BATHROOM_WITH_SINK_IN_ROOM'),
        value: 'SHARED_BATHROOM_WITH_SINK_IN_ROOM',
      },
    ];
  }

  get bathroomTypeOptions() {
    return [
      { label: i18n.t('AMENITIES.SHOWER'), value: 'SHOWER' },
      { label: i18n.t('AMENITIES.BATHTUB'), value: 'BATHTUB' },
      {
        label: i18n.t('AMENITIES.BATHTUB_OR_SHOWER'),
        value: 'BATHTUB_OR_SHOWER',
      },
      {
        label: i18n.t('AMENITIES.SEPARATE_BATHTUB_AND_SHOWER'),
        value: 'SEPARATE_BATHTUB_AND_SHOWER',
      },
      {
        label: i18n.t('AMENITIES.SHOWER_TUB_COMBINATION'),
        value: 'SHOWER_TUB_COMBINATION',
      },
    ];
  }

  get bathtubTypeOptions() {
    return [
      {
        label: i18n.t('AMENITIES.STANDARD_BATHTUB'),
        value: 'STANDARD_BATHTUB',
      },
      {
        label: i18n.t('AMENITIES.DEEP_SOAKING_BATHTUB'),
        value: 'DEEP_SOAKING_BATHTUB',
      },
      { label: i18n.t('AMENITIES.JETTED_BATHTUB'), value: 'JETTED_BATHTUB' },
      {
        label: i18n.t('AMENITIES.SPRING_WATER_BATHTUB'),
        value: 'SPRING_WATER_BATHTUB',
      },
    ];
  }

  get premiumLinenOptions() {
    return [
      {
        label: i18n.t('AMENITIES.EGYPTIAN_COTTON_SHEETS'),
        value: 'EGYPTIAN_COTTON_SHEETS',
      },
      {
        label: i18n.t('AMENITIES.FRETTE_ITALIAN_SHEETS'),
        value: 'FRETTE_ITALIAN_SHEETS',
      },
    ];
  }

  get premiumMattressOptions() {
    return [
      { label: i18n.t('AMENITIES.NOT_EXISTS'), value: '' },
      { label: i18n.t('AMENITIES.MEMORY_FOAM_MATTRESS'), value: 'MEMORY_FOAM' },
      { label: i18n.t('AMENITIES.PILLOW_TOP_MATTRESS'), value: 'PILLOW_TOP' },
      {
        label: i18n.t('AMENITIES.TEMPUR_PEDIC_MATTRESS'),
        value: 'TEMPUR_PEDIC',
      },
    ];
  }

  get kitchenTypeOptions() {
    return [
      { label: i18n.t('AMENITIES.KITCHEN'), value: 'KITCHEN' },
      { label: i18n.t('AMENITIES.KITCHENETTE'), value: 'KITCHENETTE' },
      { label: i18n.t('AMENITIES.SHARED_KITCHEN'), value: 'SHARED_KITCHEN' },
      {
        label: i18n.t('AMENITIES.SHARED_COMMUNAL_KITCHEN'),
        value: 'SHARED_COMMUNAL_KITCHEN',
      },
    ];
  }

  get refrigeratorTypeOptions() {
    return [
      { label: i18n.t('AMENITIES.REFRIGERATOR'), value: 'REFRIGERATOR' },
      {
        label: i18n.t('AMENITIES.FULL_SIZED_REFRIGERATOR_FREEZER'),
        value: 'FULL_SIZED_REFRIGERATOR_FREEZER',
      },
      {
        label: i18n.t('AMENITIES.REFRIGERATOR_ON_REQUEST'),
        value: 'REFRIGERATOR_ON_REQUEST',
      },
    ];
  }

  get microwaveTypeOptions() {
    return [
      { label: i18n.t('AMENITIES.MICROWAVE'), value: 'MICROWAVE' },
      {
        label: i18n.t('AMENITIES.MICROWAVE_ON_REQUEST'),
        value: 'MICROWAVE_ON_REQUEST',
      },
    ];
  }

  get minibarTypeOptions() {
    return [
      { label: i18n.t('AMENITIES.MINIBAR'), value: 'MINIBAR' },
      {
        label: i18n.t('AMENITIES.MINIBAR_STOCKED_FREE'),
        value: 'MINIBAR_STOCKED_FREE',
      },
      {
        label: i18n.t('AMENITIES.MINIBAR_STOCKED_FREE_CHARGED'),
        value: 'MINIBAR_STOCKED_FREE_CHARGED',
      },
    ];
  }

  get televisionTypeOptions() {
    return [
      { label: i18n.t('AMENITIES.TELEVISION'), value: 'TELEVISION' },
      { label: i18n.t('AMENITIES.FLAT_PANEL_TV'), value: 'FLAT_PANEL_TV' },
      { label: i18n.t('AMENITIES.LCD_TV'), value: 'LCD_TV' },
      { label: i18n.t('AMENITIES.LED_TV'), value: 'LED_TV' },
      { label: i18n.t('AMENITIES.SMART_TV'), value: 'SMART_TV' },
    ];
  }

  get computerTypeOptions() {
    return [
      { label: i18n.t('AMENITIES.COMPUTER'), value: 'COMPUTER' },
      { label: i18n.t('AMENITIES.TABLET'), value: 'TABLET' },
      { label: i18n.t('AMENITIES.IPAD'), value: 'IPAD' },
    ];
  }

  get channelOptions() {
    return [
      { label: i18n.t('AMENITIES.NETFLIX'), value: 'NETFLIX' },
      {
        label: i18n.t('AMENITIES.PREMIUM_CHANNELS'),
        value: 'PREMIUM_CHANNELS',
      },
      { label: i18n.t('AMENITIES.PAY_MOVIES'), value: 'PAY_MOVIES' },
      {
        label: i18n.t('AMENITIES.FIRST_RUN_MOVIES'),
        value: 'FIRST_RUN_MOVIES',
      },
    ];
  }

  get airConditioningTypeOptions() {
    return [
      {
        label: i18n.t('AMENITIES.AIR_CONDITIONING'),
        value: 'AIR_CONDITIONING',
      },
      {
        label: i18n.t('AMENITIES.IN_ROOM_CLIMATE_CONTROL'),
        value: 'IN_ROOM_CLIMATE_CONTROL',
      },
    ];
  }

  get heatingTypeOptions() {
    return [
      { label: i18n.t('AMENITIES.HEATING'), value: 'HEATING' },
      {
        label: i18n.t('AMENITIES.IN_ROOM_CLIMATE_CONTROL'),
        value: 'IN_ROOM_CLIMATE_CONTROL',
      },
    ];
  }

  addBedConfig(configs: any[]) {
    configs.push([
      {
        type: '',
        size: '',
        quantity: 1,
      },
    ]);
  }

  removeBedConfig(configs: any[], index: number) {
    configs.splice(index, 1);
  }

  addBedToConfig(config: any[]) {
    config.push({
      type: '',
      size: '',
      quantity: 1,
    });
  }

  removeBedFromConfig(config: any[], index: number) {
    config.splice(index, 1);
  }

  setExtraBed(roomType: any, value: any) {
    this.$set(roomType, 'extraBed', value ? {} : undefined);
  }

  setExtraBedCrib(options: any, value: any) {
    this.$set(
      options,
      'crib',
      value
        ? {
            quantity: 1,
            cost: 'FREE',
            price: 0,
            currency: 'EUR',
          }
        : undefined,
    );
  }

  setExtraBedRollaway(options: any, value: any) {
    this.$set(
      options,
      'rollaway',
      value
        ? {
            quantity: 1,
            cost: 'FREE',
            size: '',
            price: 0,
            currency: 'EUR',
          }
        : undefined,
    );
  }

  setExtraBedDayBed(options: any, value: any) {
    this.$set(
      options,
      'dayBed',
      value
        ? {
            quantity: 1,
            size: '',
          }
        : undefined,
    );
  }

  setOccupancy() {
    const { occupancy } = this.form.fields;
    if (typeof occupancy.total !== 'number') occupancy.total = Number(occupancy.total || 1);
    if (typeof occupancy.minAdults !== 'number') occupancy.minAdults = Number(occupancy.minAdults || 1);
    if (typeof occupancy.maxAdults !== 'number') occupancy.maxAdults = Number(occupancy.maxAdults || 1);
    if (typeof occupancy.minChildren !== 'number') occupancy.minChildren = Number(occupancy.minChildren || 0);
    if (typeof occupancy.maxChildren !== 'number') occupancy.maxChildren = Number(occupancy.maxChildren || 0);
    if (occupancy.total < 1) occupancy.total = 1;
    if (occupancy.maxAdults > occupancy.total) occupancy.maxAdults = occupancy.total;
    if (occupancy.maxAdults < 1) occupancy.maxAdults = 1;
    if (occupancy.minAdults > occupancy.maxAdults) occupancy.minAdults = occupancy.maxAdults;
    if (occupancy.minAdults < 1) occupancy.minAdults = 1;
    if (occupancy.maxChildren > occupancy.total - occupancy.minAdults)
      occupancy.maxChildren = occupancy.total - occupancy.minAdults;
    if (occupancy.maxChildren < 0) occupancy.maxChildren = 0;
    if (occupancy.minChildren > occupancy.maxChildren) occupancy.minChildren = occupancy.maxChildren;
    if (occupancy.minChildren < 0) occupancy.minChildren = 0;
  }

  onLayoutChange() {
    this.form.fields.type = '';
    this.$nextTick(() => {
      (this.$refs.roomTypeInput as any).initialize();
    });
  }

  // @Watch('form.fields.layout', { deep: true })
  // changeRoomTypeDefinition() {
  //   this.form.fields.type = ''
  //   this.$nextTick(() => {
  //     (this.$refs.roomTypeInput as any).initialize()
  //   })
  // }
}
